import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

/**
 * Estado de "no se pudo cargar", explícitamente distinto del estado vacío.
 * En las colas de admin (moderación, KYC, pedidos) un fallo de permisos se veía
 * igual que una cola vacía, y se daba por atendido lo que ni se había cargado.
 */
export default function LoadFailed({ onRetry, tokens }) {
  const { t } = useTranslation();
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
      padding: '14px 16px', borderRadius: 12,
      background: tokens?.redSoft || '#FEF2F2',
      border: `1px solid ${tokens?.red || '#DC2626'}33`,
    }}>
      <AlertTriangle size={18} color={tokens?.red || '#DC2626'} />
      <span style={{ color: tokens?.text || '#111827', fontSize: 14, flex: 1, minWidth: 200 }}>
        {t('admin.loadFailed')}
      </span>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            padding: '7px 14px', borderRadius: 8, border: 'none', cursor: 'pointer',
            background: tokens?.red || '#DC2626', color: '#fff', fontSize: 13, fontWeight: 600,
          }}
        >
          {t('errors.tryAgain')}
        </button>
      )}
    </div>
  );
}
